import { GalleryVerticalEnd } from "lucide-react";
import { LoginForm } from "../login-form";
import api from "@/lib/api";
import { loginAuth } from "@/http/loginAuth";
import { useState } from "react";
import { VIEWS } from "@/constants/views";
import { toast } from "sonner";
import { useRole } from "@/hooks/use-role";

export function ViewLogin({ setView, setUser }) {
  const [loading, setLoading] = useState(false);
  const { fetchRole } = useRole()

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true)
    const formData = new FormData(e.target);

    const body = {
      cpf: formData.get("cpf"),
      email: formData.get("email"),
      empresa: { value: formData.get("empresa") }
    }

    try {
      const data = await loginAuth(body)

      if (data.error) {
        toast.error(data.message)
        return
      }

      const user = {
        token: data.token,
        email: data.email,
        nome: data.nome,
      }

      localStorage.setItem("secretaria_user", JSON.stringify(user));

      api.defaults.headers.common['Authorization'] = `Bearer ${data.token}`

      setUser(user)
      setView(VIEWS.VIEW_DASH)
      fetchRole()

    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }

  };

  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-6 bg-muted p-6 md:p-10">
      <div className="flex w-full max-w-sm flex-col gap-6">
        <div className="flex items-center gap-2 self-center font-medium">
          <div className="flex h-6 w-6 items-center justify-center rounded-md bg-primary text-primary-foreground">
            <GalleryVerticalEnd className="size-4" />
          </div>
          Secretaria Digital
        </div>
        <LoginForm handleSubmit={handleSubmit} loading={loading} />
      </div>
    </div>
  )
}